module.exports = __webpack_public_path__ + "fb77155011dfbce32cd4245d0b149549.svg";